// extracted by mini-css-extract-plugin
export default {"warning":"_17ygO"};